// components/LocationMap.js
export default function LocationMap({ city, zip }) {
  //const address = `${city.replace(/-/g, ' ')}`.replace(/\s+/g, '+'),;
  const address = `${city.replace(/-/g, ' ')}, CA ${zip} United States`;
  //AIzaSyDuWDDHpPaiTgrukPnewiBjNLWoNy_s-ag
  //const encodedAddress = encodeURIComponent(address);
  return (
    <div className="w-full h-[400px]">
      <iframe
        title={`Map of ${address}`}
        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDBGv-j1noUjZwtVakULQerzf_HwYRliiA&q=${address}`}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}